import { createSlice } from "@reduxjs/toolkit";
import { getFinanzasV2MensualData, getFinanzasV2AnualData } from "./thunk";

const initialState = {
  mensual: null,
  anual: null,
  loading: false,
  loadingAnual: false,
  error: null,
};

const slice = createSlice({
  name: "DashboardFinanzasV2",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getFinanzasV2MensualData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getFinanzasV2MensualData.fulfilled, (state, action) => {
        state.loading = false;
        state.mensual = action.payload;
      })
      .addCase(getFinanzasV2MensualData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error?.message || "Error al cargar datos";
      })
      .addCase(getFinanzasV2AnualData.pending, (state) => {
        state.loadingAnual = true;
        state.error = null;
      })
      .addCase(getFinanzasV2AnualData.fulfilled, (state, action) => {
        state.loadingAnual = false;
        state.anual = action.payload;
      })
      .addCase(getFinanzasV2AnualData.rejected, (state, action) => {
        state.loadingAnual = false;
        state.error = action.error?.message || "Error al cargar datos";
      });
  },
});

export default slice.reducer;
